<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12Z" />
    <circle
      cx="12"
      cy="12"
      r="3"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconEye',
  props: {
    size: { type: [String, Number], default: 18 },
    strokeWidth: { type: [String, Number], default: 2 },
  },
};
</script>
